import { PageHeading } from '@quad/bootstrap-react';
import { Col, Container, Row, Stack } from 'react-bootstrap';
import { ApplicationEventLog } from '../../components/EventLog/ApplicationEventLog';
import { ApplicationPermissions } from '../../components/Permissions/ApplicationPermissions';
import { ApplicationDetails } from '../../components/ApplicationDetails/ApplicationDetails';
import { WebSitesInfo } from '../../components/WebSitesInfo/WebSitesInfo';
import { WebSitesServerManagement } from '../../components/WebSitesManagement/WebSitesServerManagement';
import { AccordionWrapper } from '../../components/UIExtentions/Accordion';
import { ApplicationPermissionClientEventSummary } from '../../signalr/models';
import { useEffect } from 'react';
import signalREventsClient from '../../signalr/SignalREventsClient';
import { UserPrincipal } from '../../permissions/userPrincipal';
import AppManagerClient from '../../api/AppManagerClient';
import React from 'react';
import ScrollPageContent from '../shared/ScrollPageContent';
import withHasPermission from '../../hoc/withHasPermission';
import { Permission } from '../../permissions/permission';
import { useParams } from 'react-router-dom';
import { AppType } from '../../constants/AppType';
import { WebSiteApplicationListing } from '../../components/WebSiteApplicationListing/WebSiteApplicationListing';

export const WebSiteDetails = withHasPermission(() => {
    const applicationName = useParams<'name'>().name!;
    const [userPrincipal, setUserPrincipal] = React.useState(new UserPrincipal([]));

    const getUserPrincipal = async (appName: string) => {
        const permissionsResult = await AppManagerClient.getWebSitesUserPermissions(appName);
        const myUserPrincipal = new UserPrincipal(permissionsResult);
        setUserPrincipal(myUserPrincipal);
    };

    useEffect(() => {
        getUserPrincipal(applicationName);
    }, [applicationName]);

    useEffect(() => {
        function isForMe(data: ApplicationPermissionClientEventSummary) {
            return data.targetApplication === applicationName;
        }

        signalREventsClient.onApplicationPermissionEvent.setHook(`WebSiteDetails_${applicationName}`, (data) => {
            if (isForMe(data)) {
                getUserPrincipal(data.targetApplication);
            }
        });
    }, [applicationName]);

    return (
        <ScrollPageContent>
            <PageHeading>
                <div className="col">
                    <h1>
                        <i className="fa fa-sitemap"></i> {applicationName} Details
                    </h1>
                </div>
            </PageHeading>

            <Stack gap={3}>
                <Container>
                    <AccordionWrapper isDefaultOpen={false} headerIcon="fa-info-circle" headerText="Application Details">
                        <Container>
                            <Row>
                                <Col sm={12} md={6}>
                                    <ApplicationDetails applicationName={applicationName} applicationType={AppType.WebSite} />
                                </Col>
                                <Col sm={12} md={6}>
                                    <WebSitesInfo applicationName={applicationName} />
                                </Col>
                            </Row>
                        </Container>
                    </AccordionWrapper>
                </Container>

                <Container>
                    <ApplicationPermissions applicationName={applicationName} userPrincipal={userPrincipal} applicationType={AppType.WebSite} />
                </Container>

                <Container>
                    <WebSitesServerManagement applicationName={applicationName} userPrincipal={userPrincipal} />
                </Container>

                <Container>
                    <WebSiteApplicationListing webSiteName={applicationName} />
                </Container>

                <Container>
                    <ApplicationEventLog applicationName={applicationName} applicationType={AppType.WebSite} />
                </Container>
            </Stack>
        </ScrollPageContent>
    );
}, Permission.Root_WebSites);
